"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFluentAsyncIterable = void 0;
const fluent_async_class_1 = require("./fluent-async-class");
const internal_utils_1 = require("./utils/internal-utils");
/**
 * Return true when the informed value is an fluent async iterable, and false otherwise
 * @param value the value to be analyzed
 * @returns The return is also a type guard, ie, inside an if with that function, the value will be considered an fluent async iterable
 */
exports.isFluentAsyncIterable = (0, internal_utils_1.isClassFactory)(fluent_async_class_1.FluentAsyncClass);
